<div class="container pt-2 pb-2 compare-versions" [ngClass]="{'isPopup':isPopup, 'mt-4': !isPopup}">
  <div style="color: orange; font-size: 27px; font-weight: 400; text-align: center" class="mb-2" *ngIf="title != ''">
    {{title}}
  </div>
  <div class="et_pb_pricing_table">
    <div class="et_pb_pricing_heading">
      <h2 class="et_pb_pricing_title m-0">Standard</h2>
    </div>
    <div class="et_pb_pricing_content_top">
      <span class="et_pb_et_price"><span class="et_pb_sum">FREE</span></span>
    </div>
    <div class="et_pb_pricing_content">
      <ul class="et_pb_pricing">
        <li><span>Only 1 picture for Posts and Messages</span></li>
        <li><span>We display ads during surfing</span></li>
        <li><span>Third party advertisement in your ads</span></li>
      </ul>
    </div>
  </div>

  <div class="et_pb_pricing_table et_pb_featured_table">
    <div class="et_pb_pricing_heading">
      <h2 class="et_pb_pricing_title m-0">Premium</h2>
    </div>
    <div class="et_pb_pricing_content_top">
      <span class="et_pb_et_price">
        <span class="et_pb_dollar_sign" style="margin-left: -10px;">$</span>
        <span class="et_pb_sum">4.60*</span><span class="et_pb_frequency">
          <span class="et_pb_frequency_slash">/</span>month
        </span>
      </span>
    </div>
    <div class="et_pb_pricing_content">
      <ul class="et_pb_pricing">
        <li><span>Unlimited pictures for Posts and Messages</span></li>
        <li><span>Ad free surfing</span></li>
        <li><span>No third party advertisement in your ads</span></li>
        <li><span>Your ads appear on top</span></li>
        <li><span>Verified badge on your user</span></li>
        <li><span>Use emojis in ads and messages</span></li>
        <li><span>Premium label</span></li>
      </ul>
    </div>
    <div class="et_pb_button_wrapper">
      <button mat-flat-button color="primary" (click)="closeAction()" routerLink="/subscription">
        Buy now!
      </button>
    </div>
  </div>

  <div class="et_pb_pricing_table et_pb_featured_table_single">
    <div class="et_pb_pricing_heading">
      <h2 class="et_pb_pricing_title m-0">Single Premium Ad</h2>
    </div>
    <div class="et_pb_pricing_content_top">
      <span class="et_pb_et_price">
        <span class="et_pb_dollar_sign" style="margin-left: -10px;">$</span>
        <span class="et_pb_sum">1.99</span><span class="et_pb_frequency">
          <span class="et_pb_frequency_slash">/</span>signle ad
        </span>
        <div style="font-size:12px;">*no monthly subscription</div>
      </span>
    </div>
    <div class="et_pb_pricing_content">
      <ul class="et_pb_pricing">
        <li><span>Unlimited pictures in single ad and ad chats</span></li>
        <li><span>No third party advertisement in your ad</span></li>
        <li><span>Your ad appears on top</span></li>
        <li><span>Verified badge on your ad</span></li>
        <li><span>Use emojis in ad and ad chats</span></li>
      </ul>
    </div>
    <div class="et_pb_button_wrapper">
      <button mat-flat-button color="primary" (click)="closeAction()" routerLink="/subscription">
        Buy now!
      </button>
    </div>
  </div>

  <div class="subs-footer pt-4" [ngClass]="{'mb-4': !isPopup}" colspan="2">
    <div class="content">
      * We strongly recommend you to reply only to verified user's ads as you know
      today's market is flooded with spam and fakes and to avoid to waste your
      valuable time by responding to ghost ads or ads which will send you to other
      websites then you should consider upgrading to premium to receive verified
      user badge on your profile, to look trustworthy for others and most
      importantly to make people want to respond to your ad or your inquiry to
      someone's ad. We can't control them in 100% but we are working 24/7 to
      discover and remove them to make your WickedList experience pleasant and
      unforgettable!
    </div>
  </div>
</div>
